import $ from 'jquery';
import pubSub from './lib/tiny-pubsub.js';
import Flickity from 'flickity-as-nav-for';
import jQueryBridget from 'jquery-bridget';

// Components
import AjaxLoad from './components/ajaxload/index';
import Collapsible from './components/collapsible/index';
import CollapsibleLight from './components/collapsible-light/index';
import ScrollToElement from './components/scroll-to-element/index';
import StickyBottomUntilElement from './components/sticky-bottom-until-element';
import MobileNavigation from './components/mobile-navigation/index';
import Tab from './components/tab/index';
import CompareComponents from './components/compare-components/index';
import CompareWidget from './components/compare-widget/index';
import FeedbackWidget from './components/feedback-widget/index';
import AutoComplete from './components/autocomplete/index';
import Menu from './components/menu/index';
import MenuTrigger from './components/menu-trigger/index';
import SlidingElement from './components/sliding-element/index';
import Slider from './components/slider/index';
import InputTarget from './components/input-target/index';
import ChildField from './components/child-field/index';
import Carousel from './components/carousel/index';
import AjaxForm from './components/ajaxform/index';
import Dialog from './components/dialog/index';
import PopUp from './components/popup/index';
import Modal from './components/modal/index';
import Expandable from './components/expandable/index';
import ExpandableCustom from './components/expandable-custom/index';
import Validator from './components/validator/index';
import Gtm from './components/gtm/index';
import StickyScroll from './components/sticky-scroll/index';
import FormDirty from './components/form-dirty/index';
import CookiePolicy from './components/cookie-policy/index';
import VideoBox from './components/video-box/index';
import BackToSearch from './components/backtosearch/index';
import ClickToToggle from './components/click-to-toggle/index';
import ClickToMap from './components/click-to-map/index';
import ClickToShow from './components/click-to-show/index';
import ClickToSlide from './components/click-to-slide/index';
import ClickToSubmit from './components/click-to-submit/index';
import ClickToShowNumber from './components/click-to-show-number/index';
import ClickToCallNumber from './components/click-to-call-number/index';
import FreespeeDynamicDealer from './components/freespee-dynamic-dealer/index';
import FreespeeDynamicAd from './components/freespee-dynamic-ad/index';
import RefineSearchToolTip from './components/refine-search-tooltip/index';
import RefineSearchMultiMakeModel from './components/refine-search-multimakemodel/index';
import Link from './components/link/index';
import DependentField from './components/dependent-field/index';
import InputMask from './components/input-mask/index';
import QuickSearchTracking from './components/quicksearch-tracking/index';
import SpTracking from './components/sp-tracking/index';
import Tooltip from './components/tooltip/index';
import PwdToggle from './components/pwd-toggle/index';
import FacebookLogin from './components/facebook-login/index';
import ButtonLoader from './components/button-loader/index';
import AdsCounterHeader from './components/adscountheader/index';
import WatchlistButton from './components/watchlistbutton/index';
import Queue from './components/queue/index';
import HierarchicalCheckbox from './components/hierarchical-checkbox/index';
import QuickSearchCounter from './components/quicksearch-counter/index';
import LinkNoHistory from './components/link-no-history/index';
import RestoreQuicksearch from './components/restore-quicksearch/index';
import ScrollupSticky from './components/scrollup-sticky';
import ClearSearchOnModalClose from './components/clear-search-on-modal-close';
import FlickityPagination from './components/flickity-pagination';
import ServiceWorkerAutomobile from './components/service-worker/index';
import PhoneButton from './components/phone-button';
import QualitySealPopupTracker from './components/quality-seal-popup-tracker';
import RentalPackageReplyForm from './components/rental-package-reply-form';
import Fbevents from './components/fbevents';
import WatchlistButtonHeader from './components/watchlistbutton-header';
import StickyBanner from './components/sticky-banner';


function app($, window) {
    const components = [
        FacebookLogin,
        QuickSearchCounter,
        AjaxLoad,
        ServiceWorkerAutomobile,
        Collapsible,
        CollapsibleLight,
        ClearSearchOnModalClose,
        ScrollToElement,
        StickyBottomUntilElement,
        MobileNavigation,
        Tab,
        CompareComponents,
        CompareWidget,
        FeedbackWidget,
        AutoComplete,
        Menu,
        MenuTrigger,
        SlidingElement,
        Slider,
        InputTarget,
        ChildField,
        Carousel,
        AjaxForm,
        Dialog,
        PopUp,
        Expandable,
        ExpandableCustom,
        Validator,
        Gtm,
        StickyScroll,
        FormDirty,
        CookiePolicy,
        VideoBox,
        BackToSearch,
        ClickToShow,
        ClickToToggle,
        ClickToSlide,
        ClickToSubmit,
        ClickToShowNumber,
        ClickToCallNumber,
        FreespeeDynamicDealer,
        FreespeeDynamicAd,
        RefineSearchToolTip,
        RefineSearchMultiMakeModel,
        Link,
        DependentField,
        InputMask,
        QuickSearchTracking,
        SpTracking,
        ClickToMap,
        Modal,
        Tooltip,
        PwdToggle,
        ButtonLoader,
        AdsCounterHeader,
        WatchlistButton,
        Queue,
        HierarchicalCheckbox,
        LinkNoHistory,
        RestoreQuicksearch,
        ScrollupSticky,
        FlickityPagination,
        PhoneButton,
        RentalPackageReplyForm,
        QualitySealPopupTracker,
        Fbevents,
        WatchlistButtonHeader,
        StickyBanner
    ];

    return {
        start() {
            pubSub($);
            window.$ = $;
            window.Flickity = Flickity;
            Flickity.setJQuery($);
            jQueryBridget('flickity', Flickity, $);
            components.forEach(component => {
                component.init(window);
            });
        }
    };
}

app($, window).start();
